export default __webpack_public_path__ + "static/media/zip.1194203a.svg";